import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {ReportJobsConfig} from '../components/ReportJobsConfig';
import ReportJobsFilterCategoryReport from '../components/ReportJobsFilterCategoryReport';
import ReportJobsFilterSelf from '../components/ReportJobsFilterSelf';
import ReportJobsSearch from '../components/ReportJobsSearch';
import ReportJobsTable from '../components/ReportJobsTable';
import {isSysopOrSysadmin, hasSectionAccess} from '../shared/authFunctions';
import FuseTheme from '../global/theme';
import Avatar from 'material-ui/Avatar';
import RaisedButton from 'material-ui/RaisedButton';
import {Card, CardText} from 'material-ui/Card';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Icon from 'material-ui/svg-icons/action/work';
import NoAccess from '../noAccess';

export const fuseReportJobsIcon = Icon;

const styles = {
    error: {fontSize: 16, color: FuseTheme.palette.errorColor},
};

/**
 * Landing Page with links to create Report Jobs and display existing Report Jobs
 *
 */
export class ReportJobs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            configData: null,
            errorMessage: null,
            reportSearch: '',
            reportSelf: false,
            reportCategory: '',
            reportChoices: [],
            reportType: '',
        };
    }

    handleConfig = (configData) => {
        this.setState({
            configData: configData
        });
    };

    handleFilterChange = (e) => {
        if (e.type === 'report-category') {
            this.setState({
                reportCategory: e.value
            });
        }
        if (e.type === 'report-type') {
            this.setState({
                reportType: e.value
            });
        }
        if (e.type === 'search') {
            this.setState({
                reportSearch: e.value
            });
        }
        if (e.type === 'self') {
            this.setState({
                reportSelf: e.value
            });
        }
    };

    render() {
        const {
            configData,
            errorMessage,
            reportCategory,
            reportSearch,
            reportSelf,
            reportType
        } = this.state;

        if (!isSysopOrSysadmin()) {
            if (!hasSectionAccess('jobs')) return <NoAccess/>;
        }

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Report Jobs</span>;

        return (
            <div className="lists-container">
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <span className="list-description hide-print">
                            <p>Assemble a new Report Job by clicking <strong>Build a Report Job</strong>.</p>
                            <br/>
                             <RaisedButton
                                 primary
                                 label="Build a Report Job"
                                 icon={<ContentAdd/>}
                                 containerElement={<Link to="/JobBuilder"/>}
                                 className="input-inline margin-right"
                             />
                            <br/><br/>
                            <p>
                                View the list of Report Jobs below. Filter by specific Report Job Types or
                                search for a specific Report Job name or description.
                            </p>
                            <p>
                                You may download completed Jobs.
                            </p>
                        </span>

                        {/* Error and Messaging */}
                        {errorMessage &&
                            <div style={styles.error}>
                                <p>{errorMessage}</p>
                            </div>
                        }

                        <div className="list-filter">
                            <form className="job-filters">
                                {configData &&
                                    <ReportJobsFilterCategoryReport
                                        configData={configData}
                                        instructions={true}
                                        onFilterChange={(e) => this.handleFilterChange(e)}
                                    />
                                }
                                <ReportJobsSearch
                                    instructions={true}
                                    onSearchSubmit={(e) => this.handleFilterChange(e)}
                                />
                                <ReportJobsFilterSelf
                                    instructions={true}
                                    onToggle={(e) => this.handleFilterChange(e)}
                                />
                            </form>
                        </div>
                        {/* Existing Report Jobs */}
                        {configData &&
                            <ReportJobsTable
                                configData={configData}
                                reportCategory={reportCategory}
                                reportSearch={reportSearch}
                                reportSelf={reportSelf}
                                reportType={reportType}
                            />
                        }
                    </CardText>
                </Card>
                <ReportJobsConfig onConfig={(e) => this.handleConfig(e)}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/views/ReportJobs.js